import NavButtons from "../components/nav-buttons";
import { Page } from "../types";
import FormPage from "../components/form-page";
import KycBioInput from "../components/kyc-bio-input";
import { useState } from "react";

type OfficerPageProps = {
  visible: boolean;
  setCurrentPage: (page: Page | undefined) => void;
  askForBeneficialOwners: boolean;
  onOfficerStateSelect: (state: string) => void;
  onOfficerTitleSelect: (title: string) => void;
  onOfficerIsOwnerChange: (isOwner: boolean) => void;
  onOfficerPercentOwnershipChange: (percentOwnership: number) => void;
  onSubmit: () => Promise<void>;
};

export default function OfficerPage({
  visible,
  setCurrentPage,
  askForBeneficialOwners,
  onOfficerStateSelect,
  onOfficerTitleSelect,
  onOfficerIsOwnerChange,
  onOfficerPercentOwnershipChange,
  onSubmit,
}: OfficerPageProps) {
  const [isValid, setIsValid] = useState(false);
  return (
    <FormPage visible={visible}>
      <h2 className="text-md lg:text-xl font-semibold">Officer Data</h2>
      <p>
        An officer is required for every fundraiser to ensure we adhere to all
        anti-money laundering laws. Our payment partner will securely validate
        your details.
      </p>
      <KycBioInput
        entityPrefix="officer"
        onValid={setIsValid}
        onStateSelect={onOfficerStateSelect}
        onTitleSelect={onOfficerTitleSelect}
        onKycIsOwnerChange={onOfficerIsOwnerChange}
        onKycPercentOwnershipChange={onOfficerPercentOwnershipChange}
        asksIsOwner={askForBeneficialOwners}
      />
      <NavButtons
        onBackClick={() => setCurrentPage("organization")}
        onNextClick={
          askForBeneficialOwners
            ? () => setCurrentPage("beneficial_owners")
            : undefined
        }
        nextButtonDisabled={!isValid}
        onSubmitClick={
          !askForBeneficialOwners
            ? async () => {
                await onSubmit();
              }
            : undefined
        }
        submitButtonDisabled={!isValid}
      />
    </FormPage>
  );
}
